export default [
  {
    path: '/power',
    name: 'Power',
    component: () => import('@/views/power/index.vue'),
    meta: {
      auth: true, // 需要登录
      title: 'XZEC 质押',
      keepAlive: true,
      headerTheme: 'dark'
    }
  },
  {
    path: '/power-log',
    name: 'PowerLog',
    component: () => import('@/views/power/powerLog.vue'),
    meta: {
      auth: true, // 需要登录
      title: '质押记录',
      keepAlive: true,
      headerTheme: 'dark'
    }
  }
]
